const getters = {
    addonProducts(state) {
        return state.addonProducts;
      },
};

export default getters;
